import { AbstractEffect } from './abstract.effect'

export class LyricsEffect extends AbstractEffect {
  static metaInfo() {
    return {
      uuid: 'lyrics',
      code: 'lyrics',
      name: 'Lyrics',
      apply: ['text']
    }
  }
}
